/**
 * ID Generator Utility
 *
 * Generates unique IDs for entities in the curriculum planning system.
 */

let counter = 0;

/**
 * Generates a unique ID with an optional prefix.
 * Uses a combination of timestamp and counter for uniqueness.
 */
export function generateId(prefix?: string): string {
  const timestamp = Date.now().toString(36);
  const random = Math.random().toString(36).substring(2, 8);
  counter++;
  const id = `${timestamp}-${random}-${counter.toString(36)}`;
  return prefix ? `${prefix}_${id}` : id;
}

/**
 * Generates a simple sequential ID with a prefix.
 * Useful for deterministic mock data generation.
 */
export function generateMockId(prefix: string, index: number): string {
  return `${prefix}-${String(index).padStart(4, '0')}`;
}
